import React, { forwardRef, useMemo } from 'react';
import cn from 'classnames';
import styles from './TableCell.module.scss';

const TableCell = forwardRef(
  (
    {
      transparent = false,
      className,
      component = 'td',
      padding,
      textAlign = 'left',
      verticalAlign = 'center',
      position,
      rowExpanded = false,
      ...props
    },
    ref
  ) => {
    const { style, ...restProps } = props;

    const cellProps = useMemo(
      () => ({
        ...restProps,
        style: { ...style, textAlign: textAlign, verticalAlign: verticalAlign },
        ref,
        className: cn(styles.root, styles[component], className, {
          [styles.empty]: padding === 'empty',
          [styles.checkbox]: padding === 'checkbox',
          [styles.transparent]: transparent,
          [styles.leftCell]: position === 'left',
          [styles.rightCell]: position === 'right',
          [styles.bottomLeftCell]: position === 'bottomLeft',
          [styles.bottomRightCell]: position === 'bottomRight',
          [styles.expanded]: rowExpanded,
        }),
      }),
      [
        className,
        ref,
        textAlign,
        verticalAlign,
        component,
        padding,
        transparent,
        position,
        rowExpanded,
        props,
      ]
    );

    if (component === 'th') {
      return <th {...cellProps} />;
    }

    return <td {...cellProps} />;
  }
);

export default TableCell;
